import { useEffect, useState } from "react";
import { useApp } from "../../../../services/app-context";
import { ShowToast } from "../../../../services/toast";
import { secondsToMinute } from "../../utils";
import { TranscriptView } from "../TranscriptView";
import InsightsView from "./components/InsightsView";
import { useAnalytics } from "../../../../integrations/posthog/useAnalytics";
import { PRAXIS_PLAY_EVENTS } from "../../../../integrations/posthog/events";
import { isCertificationModeEnabled } from "../../../../integrations/posthog/featureFlags";

function ManagerComments({ comments }: { comments: string }) {
  return (
    <div className="relative bg-white pt-11 rounded-md">
      <div className="absolute top-0 left-0 w-full border border-[#DEDEDE] bg-[#B4B4B421] rounded-[7px] h-11 flex items-center px-4 text-text2 text-[17px] leading-[20.5px]">
        Manager Comments and Feedback
      </div>
      <div className="bg-white rounded-md p-4">
        {comments}
      </div>
    </div>
  );
}

export function SessionRecap({
  report,
  currentIndex,
  setCurrentIndex,
  metrics,
  detailedReport,
}: {
  currentIndex?: number;
  setCurrentIndex?: (index: number) => void;
  metrics?: any;
  report?: any;
  detailedReport?: any;
}) {
  const { captureEvent } = useAnalytics();

  const isCertificationMode = isCertificationModeEnabled();
  const [activeTab, setActiveTab] = useState<string>("");

  useEffect(() => {
    if (detailedReport) {
      captureEvent(PRAXIS_PLAY_EVENTS.DETAILED_REPORT_ACCESSED, {
        session_id: detailedReport?.session?.sessionID,
        source: "feedback_session_recap_tab"
      });
    }
  }, [detailedReport]);

  return (
    <div>
      <div
        className={`flex flex-col gap-4 mt-4 ${isCertificationMode ? "lg:flex-row" : ""
          }`}
      >
        {isCertificationMode && (
          <>
            {report?.videoUrl && <div className="h-[478px] w-full lg:w-[650px] rounded-lg mt-4">
              <video
                className="w-full h-full object-contain rounded-lg"
                src={report?.videoUrl}
                controls
                playsInline
                onError={() => {
                  ShowToast({
                    message: "Error loading video",
                    type: "error",
                  });
                }}
              />
            </div>}
            {report?.managerComments && <ManagerComments comments={report?.managerComments} />}
          </>
        )}
      </div>
      <div
        className={`flex flex-col gap-4 mt-4 md:flex-row`}
      >
        <div className={`${activeTab ? "flex-[2]" : "w-[333px]"}`}>
          <InsightsView
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            detailedReport={detailedReport}
          />
        </div>

        <div className="flex-1 w-full">
          <TranscriptView
            conversations={report?.conversations || []}
            currentIndex={currentIndex}
            activeTab={activeTab}
            report={detailedReport?.report || []}
            titleClassName="!text-sm !font-semibold"
          />
        </div>
      </div>
    </div>
  );
}
